import { isBirthdate } from 'reactUtils/validators/validators'
import { isAcceptedAge } from 'reactUtils/date-helpers/date-helpers'

export const birthdateErrorMessage = value => {
  if (!isBirthdate(value)) {
    return 'Data de nascimento inválida'
  }

  if (!isAcceptedAge(value)) {
    return 'Você precisa ter entre 18 e 100 anos para participar'
  }

  return true
}
